import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDbIcFilter20 = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "icon",
	height: 20,
	viewBox: "0 0 20 20",
	width: 20,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m7 10a2.94 2.94 0 0 1 2.813 2h7.124c.563 0 1 .438 1 1 0 .531-.437 1-1 1h-7.124a2.953 2.953 0 0 1 -2.813 1.969 2.953 2.953 0 0 1 -2.813-1.969h-1.187c-.563 0-1-.469-1-1 0-.562.438-1 1-1h1.188a2.94 2.94 0 0 1 2.812-2zm0 1.969c-.563 0-1 .469-1 1 0 .562.438 1 1 1 .563 0 1-.438 1-1 0-.563-.469-1-1-1zm5.969-7.969a2.98 2.98 0 0 1 2.812 2h1.219c.469 0 .969.313 1 1 0 .563-.438 1-1 1h-1.188c-.437 1.156-1.53 2-2.843 2a2.98 2.98 0 0 1 -2.813-2h-7.156c-.469 0-.969-.344-1-1 0-.562.438-1 1-1h7.156a3.01 3.01 0 0 1 2.813-2zm0 2c-.531 0-1 .438-1 1 0 .563.469 1 1 1 .562 0 1-.437 1-1 0-.562-.469-1-1-1z",
		fill: "var(--db-icon-color, currentColor)",
		fillRule: "evenodd"
	})
});
export default SvgDbIcFilter20;
